var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1008 8.37695C31.1008 8.37695 29.1975 10.2793 25.0764 10.2793C21.9563 10.2793 18.3791 10.5928 15.9993 13.7735C13.6194 10.5928 10.0422 10.2793 6.92307 10.2793C2.801 10.2793 0.898629 8.37695 0.898629 8.37695C0.898629 8.37695 -1.57793 13.6084 1.69163 19.0195C4.259 23.2666 9.301 24.25 12.6301 23.2793C14.2776 22.7988 15.6096 21.5683 15.9993 21.1816C16.3889 21.5683 17.7219 22.7988 19.3694 23.2793C22.6985 24.25 27.7405 23.2666 30.3089 19.0195C33.5784 13.6084 31.1008 8.37695 31.1008 8.37695ZM8.88888 18.254C6.99432 17.8321 5.85763 16.336 6.03925 15.3643C6.18475 14.5909 9.092 14.4122 10.3537 14.8888C11.6174 15.3653 12.6281 16.0216 12.6389 16.7648C12.6496 17.5068 10.7844 18.6758 8.88888 18.254ZM23.1096 18.254C21.215 18.6758 19.3498 17.5069 19.3596 16.7647C19.3703 16.0215 20.383 15.3653 21.6448 14.8887C22.9065 14.4121 25.8137 14.5908 25.9602 15.3643C26.1418 16.336 25.0051 17.8321 23.1096 18.254Z",
    fill: "#66B929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymous);
export default __webpack_public_path__ + "static/media/anonymous.75b6a594f2d67e1ea4aaab86e91c8db6.svg";
export { ForwardRef as ReactComponent };